module.exports = __webpack_public_path__ + "static/media/06_elcomercio.3cdd978f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/06_elcomercio.png
// module id = 530
// module chunks = 0